import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useNavigation } from '../../../common/navigation';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface NewWindowButtonProps {
  contractId?: string;
  tv?: boolean;
}

export const NewWindowButton: React.FC<NewWindowButtonProps> = props => {
  const nav = useNavigation();
  const { t, tk } = useTranslation('projectLng');

  const handleClick = () => {
    if (props.contractId) {
      if (props.tv) {
        nav.contractEditorTV(props.contractId, true);
      } else {
        nav.contractEditor(props.contractId, true);
      }
    }
  };

  return (
    <OverlayTrigger overlay={<Tooltip>{t(tk.common.openNewCard)}</Tooltip>}>
      <Button
        onClick={e => {
          e.stopPropagation();
          handleClick();
        }}
        variant="btn-info"
        className="px-2"
      >
        <Icon.BoxArrowUpRight className="icon-blue" size={16} />
      </Button>
    </OverlayTrigger>
  );
};
